var map = {
	"./body-acne1.png": 3765,
	"./body-acne2.png": 8934,
	"./body-acne3.png": 1752,
	"./body-acne4.png": 8463,
	"./body-blood1.png": 6430,
	"./body-blood2.png": 1259,
	"./body-blood3.png": 5987,
	"./body-blood4.png": 6284,
	"./body-bodyFat2.png": 3935,
	"./body-bodyFat3.png": 1719,
	"./body-bodyFat4.png": 8730,
	"./body-bone1.png": 2855,
	"./body-bone2.png": 9449,
	"./body-bone3.png": 2557,
	"./body-bone4.png": 5626,
	"./body-brain1.png": 6549,
	"./body-brain2.png": 647,
	"./body-brain3.png": 3986,
	"./body-brain4.png": 4367,
	"./body-gynecomastia1.png": 5773,
	"./body-gynecomastia2.png": 8779,
	"./body-gynecomastia3.png": 858,
	"./body-gynecomastia4.png": 9364,
	"./body-hair0.png": 8953,
	"./body-hair1.png": 7796,
	"./body-hair2.png": 3759,
	"./body-hair3.png": 6569,
	"./body-hair4.png": 976,
	"./body-headache1.png": 280,
	"./body-headache2.png": 8205,
	"./body-headache3.png": 7357,
	"./body-headache4.png": 7223,
	"./body-heart1.png": 370,
	"./body-heart2.png": 2498,
	"./body-heart3.png": 687,
	"./body-heart4.png": 2196,
	"./body-infectionRisk1.png": 7103,
	"./body-infectionRisk2.png": 6911,
	"./body-infectionRisk3.png": 3436,
	"./body-infectionRisk4.png": 1583,
	"./body-kidney1.png": 3426,
	"./body-kidney2.png": 6152,
	"./body-kidney3.png": 4829,
	"./body-kidney4.png": 3217,
	"./body-liver1.png": 1629,
	"./body-liver2.png": 151,
	"./body-liver3.png": 4232,
	"./body-liver4.png": 8708,
	"./body-mood0.png": 407,
	"./body-mood1.png": 6772,
	"./body-mood2.png": 4486,
	"./body-mood3.png": 6154,
	"./body-mood4.png": 9709,
	"./body-muscleMass2.png": 5463,
	"./body-muscleMass3.png": 9806,
	"./body-muscleMass4.png": 5569,
	"./body-organs.png": 4689
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6275;